import { useMemo } from 'react';
import useOwnedPhotoSchemas from '@/hooks/useOwnedPhotoSchemas';
import { makeReclaimedOldeSchemas } from '@/data/reclaimedOldeImages';
const award = "/images/site/reclaimed-barnwood-floor-rubio-monocoat-farmington-hills-mi.webp";
import vent from '@/assets/reclaimed-project-vent.webp';
import closeup from '@/assets/reclaimed-project-closeup.webp';
import wide from '@/assets/reclaimed-ceiling-wide.webp';
import vaulted from '@/assets/reclaimed-ceiling-vaulted.webp';
import detail from '@/assets/reclaimed-ceiling-detail.webp';
const assets: Record<string, string> = { 'award-closeup': award, 'reclaimed-project-vent': vent, 'reclaimed-project-closeup': closeup, 'reclaimed-ceiling-wide': wide, 'reclaimed-ceiling-vaulted': vaulted, 'reclaimed-ceiling-detail': detail };
export default function useReclaimedOldePhotos(path: string) {
  const schemas = useMemo(() => makeReclaimedOldeSchemas(path, (name: string) => {
    const src = assets[name];
    return src ? `https://1woodfloors.com${src}` : undefined;
  }), [path]);
  useOwnedPhotoSchemas(schemas);
}
